<script setup lang="ts">
import CardDialog from '@/components/dialogs/CardDialog.vue'
import CheckList from '@/components/feedback/lists/CheckList.vue'
import * as _ from 'lodash-es'
import { useI18n } from 'vue-i18n'

interface Props {
  /** List of restrictions to display */
  restrictions: RestrictionResource[]
}

defineProps<Props>()

defineOptions({
  name: 'RestrictionDialog'
})

const { t } = useI18n()
</script>

<template>
  <CardDialog hide-cancel @action="({ close }) => close()">
    <template #prepend-title>
      <VIcon icon="$information" color="blue" size="2rem" />
    </template>

    <CheckList
      icon="$close"
      color="danger"
      :items="_.map(restrictions, 'name')"
    />

    <template #action>
      {{ t('general.close_notification') }}
    </template>
  </CardDialog>
</template>
